import { useState, useEffect } from 'react';
import client from '../../api/client';

export default function AdminDashboard() {
    const [suburbs, setSuburbs] = useState([]);
    const [skills,  setSkills]  = useState([]);

    useEffect(() => {
        client.get('/ref/suburbs').then(r => setSuburbs(r.data.suburbs));
        client.get('/ref/skills').then(r  => setSkills(r.data.skills));
    }, []);

    return (
        <div style={styles.page}>
            <h1 style={styles.title}>Admin Dashboard</h1>
            <div style={styles.grid}>
                <div style={styles.card}>
                    <h3 style={styles.cardTitle}>📍 Suburbs ({suburbs.length})</h3>
                    <table style={styles.table}>
                        <thead><tr><th style={styles.th}>ID</th><th style={styles.th}>Suburb</th><th style={styles.th}>Postcode</th><th style={styles.th}>State</th></tr></thead>
                        <tbody>{suburbs.map(s=><tr key={s.suburb_id}><td style={styles.td}>{s.suburb_id}</td><td style={styles.td}>{s.suburb_name}</td><td style={styles.td}>{s.postcode}</td><td style={styles.td}>{s.state}</td></tr>)}</tbody>
                    </table>
                </div>
                <div style={styles.card}>
                    <h3 style={styles.cardTitle}>🛠 Skills ({skills.length})</h3>
                    <table style={styles.table}>
                        <thead><tr><th style={styles.th}>ID</th><th style={styles.th}>Skill</th><th style={styles.th}>Category</th></tr></thead>
                        <tbody>{skills.map(s=><tr key={s.skill_id}><td style={styles.td}>{s.skill_id}</td><td style={styles.td}>{s.skill_name}</td><td style={styles.td}>{s.category}</td></tr>)}</tbody>
                    </table>
                </div>
            </div>
        </div>
    );
}

const styles = {
    page:      { maxWidth:'1200px', margin:'0 auto', padding:'32px 24px' },
    title:     { color:'#2d6a4f', marginBottom:'24px' },
    grid:      { display:'grid', gridTemplateColumns:'1fr 1fr', gap:'24px' },
    card:      { background:'white', borderRadius:'10px', padding:'24px', boxShadow:'0 2px 8px rgba(0,0,0,0.08)' },
    cardTitle: { margin:'0 0 16px', color:'#333', fontSize:'1.1rem' },
    table:     { width:'100%', borderCollapse:'collapse', fontSize:'0.88rem' },
    th:        { textAlign:'left', padding:'8px', borderBottom:'2px solid #eee', color:'#666', fontWeight:'600' },
    td:        { padding:'7px 8px', borderBottom:'1px solid #f5f5f5', color:'#333' },
};
